import { Box, Button, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

const MissingContactDataModal = observer(
  ({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element => {
    const navigate = useNavigate();

    const handleGoToMyData = () => {
      onClose();
      navigate('/meine-daten');
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle color="secondary">Information</DialogTitle>
        <DialogContent>
          <Box sx={{ paddingX: 2, paddingY: 1 }}>
            <Typography>
              Sie haben noch keine Kontaktdaten angegeben, bitte füllen Sie
              diese aus.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Schließen</Button>
          <Button
            onClick={handleGoToMyData}
            variant="contained"
            color="primary"
          >
            Zu meinen Daten
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default MissingContactDataModal;
